import { inject } from 'mobx-react';
import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from 'bernie-view';

import { PropertyNavigationBar } from '@shared-ui/lodging-property-details';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

// UITK
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

import { StickyBookBar } from 'components/infosite/template-components/sticky-book-bar';

interface NavBarWithQuickReserveButtonProps {
  inputs?: any;
  showNightlyPrice?: boolean;
}
interface NavBarWithReserveButtonProps {
  currentHotel?: CurrentHotelStore;
  inputs?: any;
  showNightlyPrice?: boolean;
}

interface NavBarNightlyPriceProps {
  stickyOffer?: any;
}

const NavBarNightlyPrice: React.FC<NavBarNightlyPriceProps> = ({ stickyOffer }) => (
  <>
    <UitkSpacing margin={{ inlineend: 'unset' }}>
      <UitkText weight="bold" data-stid="navbar-room-nightly-price" size={500} align="right" inline={true}>
        {stickyOffer.price}
      </UitkText>
    </UitkSpacing>
    {stickyOffer.qualifier && (
      <UitkText theme="secondary" data-stid="navbar-room-nightly-qualifier" spacing="one" size={200} inline={true}>
        {stickyOffer.qualifier}
      </UitkText>
    )}
  </>
);
const NavBarWithReserveButton: React.FC<NavBarWithReserveButtonProps> = inject('currentHotel')(
  ({ inputs, currentHotel, showNightlyPrice }) => {
    const { offers } = currentHotel || {};
    const stickyOffer = offers && offers.stickyOffer;

    return (
      <UitkLayoutFlex space="two" justifyContent="space-between" alignItems="center">
        <UitkLayoutFlexItem grow={3}>
          <div>
            <PropertyNavigationBar inputs={inputs} />
          </div>
        </UitkLayoutFlexItem>

        {showNightlyPrice && stickyOffer?.price && (
          <UitkLayoutFlexItem grow={0}>
            <NavBarNightlyPrice stickyOffer={stickyOffer} />
          </UitkLayoutFlexItem>
        )}

        {stickyOffer?.buttonText && (
          <UitkLayoutFlexItem grow={0}>
            <UitkSpacing padding={{ inlineend: 'three' }}>
              <div data-stid="navbar-quick-reserve-button">
                <StickyBookBar />
              </div>
            </UitkSpacing>
          </UitkLayoutFlexItem>
        )}
      </UitkLayoutFlex>
    );
  }
);
export const NavBarWithQuickReserveButton: React.FC<NavBarWithQuickReserveButtonProps> = ({ inputs, showNightlyPrice }) => (
  <Viewport>
    <ViewSmall>
      <PropertyNavigationBar inputs={inputs} />
    </ViewSmall>
    <ViewLarge>
      <NavBarWithReserveButton inputs={inputs} showNightlyPrice={showNightlyPrice} />
    </ViewLarge>
  </Viewport>
);
